import { createVNode as n, mergeProps as m } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/NotFoundTwoTone.js";
import a from "../components/PfIcon.js";
const o = (t, r) => {
  const e = {
    ...t,
    ...r.attrs
  };
  return n(a, m(e, {
    icon: s
  }), null);
};
o.displayName = "NotFoundTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
